/**
 * 渠道房型价格：第三方接口直调 + 时间戳 + 本地缓存（内存 + localStorage）+ 字段对齐组件
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getChannelPriceFromThirdParty, getStoreRevenueComponent, } from '../../../../service/storeRevenueApi';
import { getStoreFromLocalStorage, setStoreSliceInLocalStorage } from '../../../utils/storeRevenueLocalStorage';
var CHANNEL_PRICE_TTL_MS = 2 * 60 * 1000; // 2 分钟
var channelPriceCache = new Map();
var inFlightChannelPrice = new Map();
function cacheKey(hotelId) {
    return "channelPrice:".concat(String(hotelId));
}
function isValid(entry) {
    return Date.now() - entry.fetchedAt < CHANNEL_PRICE_TTL_MS;
}
function isPriceChannelResponse(v) {
    if (v == null || typeof v !== 'object')
        return false;
    var o = v;
    return o.code === 1 && o.data != null && typeof o.data === 'object' && Array.isArray(o.data.roomTypeList);
}
/** 冷启动从 localStorage 恢复，供 hook 做初始渲染 */
function hydrateFromLocalStorage(hotelId) {
    var _a;
    var stored = (_a = getStoreFromLocalStorage(hotelId)) === null || _a === void 0 ? void 0 : _a.channelPrice;
    if (!(stored === null || stored === void 0 ? void 0 : stored.data) || typeof stored.fetchedAt !== 'number')
        return null;
    if (Date.now() - stored.fetchedAt > CHANNEL_PRICE_TTL_MS)
        return null;
    if (!isPriceChannelResponse(stored.data))
        return null;
    var entry = { data: stored.data, fetchedAt: stored.fetchedAt };
    channelPriceCache.set(cacheKey(hotelId), entry);
    return stored.data;
}
export function getChannelPriceFromLocalStorageSync(hotelId) {
    return hydrateFromLocalStorage(hotelId);
}
export function getChannelPriceWithCache(hotelId) {
    return __awaiter(this, void 0, Promise, function () {
        var key, entry, fromLocal, inFlight, promise;
        var _this = this;
        return __generator(this, function (_a) {
            key = cacheKey(hotelId);
            entry = channelPriceCache.get(key);
            if (entry && isValid(entry))
                return [2 /*return*/, entry.data];
            fromLocal = hydrateFromLocalStorage(hotelId);
            if (fromLocal != null)
                return [2 /*return*/, fromLocal];
            inFlight = inFlightChannelPrice.get(key);
            if (inFlight)
                return [2 /*return*/, inFlight];
            promise = (function () { return __awaiter(_this, void 0, Promise, function () {
                var data, fetchedAt, directErr_1, slice, chartData, fetchedAt, _a;
                var _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _c.trys.push([0, 2, , 7]);
                            return [4 /*yield*/, getChannelPriceFromThirdParty(hotelId)];
                        case 1:
                            data = _c.sent();
                            fetchedAt = Date.now();
                            channelPriceCache.set(key, { data: data, fetchedAt: fetchedAt });
                            setStoreSliceInLocalStorage(hotelId, 'channelPrice', { data: data, fetchedAt: fetchedAt });
                            return [2 /*return*/, data];
                        case 2:
                            directErr_1 = _c.sent();
                            if (process.env.NODE_ENV === 'development') {
                                console.warn('[渠道房型价格] 直调 PMS 失败，尝试后端回退', { hotelId: hotelId, err: directErr_1 });
                            }
                            _c.label = 3;
                        case 3:
                            _c.trys.push([3, 5, , 6]);
                            return [4 /*yield*/, getStoreRevenueComponent(hotelId, 'channel-price')];
                        case 4:
                            slice = _c.sent();
                            chartData = (_b = slice.channelPrice) === null || _b === void 0 ? void 0 : _b.chartData;
                            if (isPriceChannelResponse(chartData)) {
                                fetchedAt = Date.now();
                                channelPriceCache.set(key, { data: chartData, fetchedAt: fetchedAt });
                                setStoreSliceInLocalStorage(hotelId, 'channelPrice', { data: chartData, fetchedAt: fetchedAt });
                                return [2 /*return*/, chartData];
                            }
                            return [3 /*break*/, 6];
                        case 5:
                            _a = _c.sent();
                            return [3 /*break*/, 6];
                        case 6: return [2 /*return*/, null];
                        case 7: return [2 /*return*/];
                    }
                });
            }); })().finally(function () { inFlightChannelPrice.delete(key); });
            inFlightChannelPrice.set(key, promise);
            return [2 /*return*/, promise];
        });
    });
}
export function clearChannelPriceCache(hotelId) {
    var key = cacheKey(hotelId);
    channelPriceCache.delete(key);
    inFlightChannelPrice.delete(key);
}
export function __getChannelPriceCacheForDev() {
    return channelPriceCache;
}
